import React from 'react';
import { Box, Typography } from '@mui/material';
import Footer from '@top/components/Footer';
// 特集カード（skillthホーム画面のヒーロー領域）のサンプルデータ
// Skillth.dc.html:3615-3621 準拠
const portalCards = [
    { tag: '無料公開中', title: '2026年の学びのトレンド', tone: 'rgb(1,42,74)' },
    { tag: '7日間無料', title: 'データ分析入門', tone: 'rgb(25,118,210)' },
    { tag: 'SNSマーケティングの基本', title: '拡散する企画のつくり方', tone: 'rgb(46,125,50)' },
    { tag: 'マネジメント術', title: '1on1で伸ばすチーム', tone: 'rgb(198,40,40)' },
    { tag: 'OJTの方法', title: '現場で育てる仕組み', tone: 'rgb(120,80,180)' },
];
// skillthの特徴セクションのサンプルデータ
// 元は Skillth.dc.html:3622-3627 準拠の4ステップだったが、他己評価は表示を削除したため3ステップ
const portalSteps = [
    { step: 'ステップ1', title: 'スキル診断', icon: '🧑‍💻', desc: '簡単なテストで自分のスキルを可視化できます' },
    { step: 'ステップ2', title: '自動の棚卸し', icon: '📋', desc: '組織全体のスキルを自動で集計します' },
    { step: 'ステップ3', title: 'スキルアップ', icon: '🚀', desc: '不足スキルに合った学習を提案します' },
];
// ユーザーランキングのサンプルデータ（Skillth.dc.html:3628-3634 準拠）
const portalRanking = [
    { rank: '1', name: '藤井 直司', score: '93.2%', up: '+300%' },
    { rank: '2', name: '鈴木 茂樹', score: '92.1%', up: '+110%' },
    { rank: '3', name: '石井 弘一郎', score: '91.1%', up: '+89%' },
    { rank: '4', name: '平田 啓太', score: '91.1%', up: '+57%' },
    { rank: '5', name: '田代 陽助', score: '91.1%', up: '+33%' },
];
// 特集カードエリア（ヒーロー）: 静的横スクロール（Skillth.dc.html:242-252 準拠）
const PortalHero = () => (React.createElement(Box, { sx: { bgcolor: 'rgb(240,242,245)', px: { xs: 2.5, md: 5 }, pt: 4.5, pb: 3.25 } },
    React.createElement(Box, { sx: { display: 'flex', gap: 2, overflowX: 'auto', pb: 0.75 } }, portalCards.map((card) => (React.createElement(Box, { key: card.title, sx: {
            flex: '0 0 200px',
            bgcolor: 'background.paper',
            border: '1px solid rgb(224,224,224)',
            borderRadius: '6px',
            overflow: 'hidden',
            cursor: 'pointer',
        } },
        React.createElement(Box, { sx: {
                height: 140,
                borderRadius: '6px 6px 0 0',
                bgcolor: card.tone,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: 13,
                fontWeight: 700,
                textAlign: 'center',
                px: 1.5,
            } }, card.tag),
        React.createElement(Box, { sx: { px: 1.75, pt: 1.5, pb: 2 } },
            React.createElement(Typography, { sx: { fontSize: 13, fontWeight: 600, color: 'rgba(0,0,0,0.8)', lineHeight: 1.5 } }, card.title)))))),
    React.createElement(Typography, { sx: { textAlign: 'right', mt: 1.75, fontSize: 12, color: 'rgba(0,0,0,0.5)', cursor: 'pointer' } }, "\u3059\u3079\u3066\u306E\u7279\u96C6 \u203A")));
// INFORMATION バー: ヒーロー直下の独立した1行バー（Skillth.dc.html:254-259 準拠）
const InformationBar = () => (React.createElement(Box, { sx: {
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        px: { xs: 2.5, md: 5 },
        py: 2.25,
        borderBottom: '1px solid rgb(230,230,230)',
        bgcolor: 'background.paper',
    } },
    React.createElement(Typography, { sx: { fontSize: 12, fontWeight: 700, color: 'rgba(0,0,0,0.8)', letterSpacing: '0.5px' } }, "INFORMATION"),
    React.createElement(Typography, { sx: { fontSize: 12, color: 'rgba(0,0,0,0.45)' } }, "2026/07/19"),
    React.createElement(Typography, { sx: { flex: 1, fontSize: 13, color: 'rgba(0,0,0,0.8)' } }, "\u3010\u7121\u6599\u516C\u958B\u4E2D\u30112026\u5E74\u306E\u5B66\u3073\u306E\u30C8\u30EC\u30F3\u30C9\uFF01skillth\u4EBA\u6C17\u8B1B\u5EA7\u30E9\u30F3\u30AD\u30F3\u30B0"),
    React.createElement(Typography, { sx: { color: 'rgba(0,0,0,0.3)' } }, "\u203A")));
// Main TopPage component
const TopPage = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, null,
            React.createElement(PortalHero, null),
            React.createElement(InformationBar, null),
            React.createElement(Box, { sx: { px: { xs: 2.5, md: 5 }, pt: 4, pb: 5 } },
                React.createElement(Typography, { component: "h1", sx: { fontSize: 16, fontWeight: 700, color: 'rgba(0,0,0,0.87)', mb: 2 } }, "skillth\u306E\u7279\u5FB4"),
                React.createElement(Box, { sx: {
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: 2,
                        mb: 4,
                    } }, portalSteps.map((s) => (React.createElement(Box, { key: s.step, sx: {
                        border: '1px solid rgb(224,224,224)',
                        borderRadius: '6px',
                        overflow: 'hidden',
                        bgcolor: 'background.paper',
                        minWidth: 0,
                    } },
                    React.createElement(Box, { sx: {
                            bgcolor: 'rgb(1,42,74)',
                            color: '#fff',
                            textAlign: 'center',
                            py: 1.125,
                            fontSize: 13,
                            fontWeight: 600,
                        } }, s.step),
                    React.createElement(Box, { sx: { px: 2, pt: 2.25, pb: 2.75, textAlign: 'center' } },
                        React.createElement(Typography, { sx: { fontSize: 15, fontWeight: 700, color: 'rgba(0,0,0,0.87)', mb: 1.5 } }, s.title),
                        React.createElement(Typography, { sx: { fontSize: 34, lineHeight: 1, mb: 1.75 } }, s.icon),
                        React.createElement(Typography, { sx: { fontSize: 12, color: 'rgba(0,0,0,0.55)', lineHeight: 1.7 } }, s.desc)))))),
                React.createElement(Box, { sx: {
                        maxWidth: 520,
                        border: '1px solid rgb(224,224,224)',
                        borderRadius: '6px',
                        bgcolor: 'background.paper',
                        px: 3,
                        py: 2.75,
                    } },
                    React.createElement(Box, { sx: { display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', mb: 2 } },
                        React.createElement(Typography, { sx: { fontSize: 15, fontWeight: 700, color: 'rgba(0,0,0,0.87)' } }, "\u30E6\u30FC\u30B6\u30FC\u30E9\u30F3\u30AD\u30F3\u30B0"),
                        React.createElement(Typography, { sx: { fontSize: 11, color: 'rgba(0,0,0,0.45)' } }, "\u6700\u7D42\u66F4\u65B0\u65E5: 2026.07.24 12:30")),
                    React.createElement(Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            pb: 1.25,
                            borderBottom: '1px solid rgb(235,235,235)',
                            fontSize: 12,
                            color: 'rgba(0,0,0,0.5)',
                        } },
                        React.createElement(Box, { sx: { width: 56 } }, "\u9806\u4F4D"),
                        React.createElement(Box, { sx: { flex: 1 } }, "\u540D\u524D"),
                        React.createElement(Box, { sx: { width: 80 } }, "\u30B9\u30B3\u30A2"),
                        React.createElement(Box, { sx: { width: 80 } }, "\u4E0A\u6607\u7387")),
                    portalRanking.map((r) => (React.createElement(Box, { key: r.rank, sx: {
                            display: 'flex',
                            alignItems: 'center',
                            py: 1.375,
                            borderBottom: '1px solid rgb(242,242,242)',
                            fontSize: 13,
                            color: 'rgba(0,0,0,0.85)',
                        } },
                        React.createElement(Box, { sx: { width: 56 } },
                            React.createElement(Box, { sx: {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: 22,
                                    height: 22,
                                    borderRadius: '4px',
                                    bgcolor: 'rgb(1,42,74)',
                                    color: '#fff',
                                    fontSize: 11,
                                    fontWeight: 700,
                                } }, r.rank)),
                        React.createElement(Box, { sx: { flex: 1 } }, r.name),
                        React.createElement(Box, { sx: { width: 80 } }, r.score),
                        React.createElement(Box, { sx: { width: 80, color: 'rgb(46,125,50)' } }, r.up)))),
                    React.createElement(Typography, { sx: { textAlign: 'right', pt: 1.5, fontSize: 12, color: 'rgb(1,42,74)', cursor: 'pointer' } }, "\u3082\u3063\u3068\u898B\u308B")))),
        React.createElement(Footer, null)));
};
export default TopPage;
